export default "__VITE_ASSET__dRxqL6zB__"